import React, { useCallback } from 'react'

import type { GameWithUserInformation } from 'containers/GamesBlock/types'

import useGameDialog from '../../MobileDialog/hooks/useGameDialog'
import { Image } from '../Image'
import { Title } from '../Title'
import { GameBox } from './styles'

interface Props {
  game: GameWithUserInformation
}

export function MobileGame({ game }: Props) {
  const { slug } = game
  const { open } = useGameDialog()
  const onOpen = useCallback(() => open(slug), [slug, open])

  return (
    <GameBox>
      <Image
        onClick={onOpen}
        game={game}
      />
      <Title
        onClick={onOpen}
        game={game}
      />
    </GameBox>
  )
}
